module.exports = __webpack_public_path__ + "static/media/51.558b6f05.jpg";